import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tempoPercorrido'
})
export class TempoPercorridoPipe implements PipeTransform {
  transform(dataHoraPedido: string): string {
    const dataPedido = new Date(dataHoraPedido);
    const agora = new Date();
    const diffEmMinutos = (agora.getTime() - dataPedido.getTime()) / 60000;

    if (diffEmMinutos <= 10) {
      return '';
    } else if (diffEmMinutos <= 30) {
      return 'bg-warning border-warning';
    } else {
      return 'bg-danger border-danger';
    }
  }
}
